// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"ne-z","categoryName":"oe-z","categoryImage":"pe-z","categoryContent":"qe-z","bottomAligned":"re-z"};